var firebaseConfig = {
    apiKey: "AIzaSyC9LAD-6qLwgSJqn5--7JSVjnq6HY-3scw",
    authDomain: "dynamicwec-f88f4.firebaseapp.com",
    projectId: "dynamicwec-f88f4",
    storageBucket: "dynamicwec-f88f4.appspot.com",
    messagingSenderId: "63330429771",
    appId: "1:63330429771:web:b17dfc0959ab7e961a56ce",
  };
  export default firebaseConfig;
